import { Checkbox, Table } from "antd";
import { ColumnType } from "antd/es/table";
import { Dispatch } from "react";
import { useTranslation } from "react-i18next";
import { SetStateAction } from "react";
import { UseMutateAsyncFunction } from "react-query";
import { AxiosResponse } from "axios";

interface Props {
  items: any;
  isLoading: boolean;
  selectedItems: any;
  setSelectedItems: Dispatch<any>;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  getItemsSearchMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    void,
    unknown
  >;
  tableKey: string;
}

const ItemsList = ({
  items,
  isLoading,
  selectedItems,
  setSelectedItems,
  setPage,
  page,
  tableKey,
  getItemsSearchMutation,
}: Props) => {
  const [t] = useTranslation("common");
  interface DataSourceItem {
    id: number;
    barcode: string;
    name: string;
    author: string;
    year: string;
    description: string;
    qtyInStock: number;
    price: number;
  }
  const columns: ColumnType<DataSourceItem>[] = [
    {
      title: `${t("select")}`,
      width: "1rem",
      align: "center",
      className: "table-row main",
      render: (record: any) => {
        return (
          <Checkbox
            defaultChecked={selectedItems.some(
              (item: any) => item.id === record.id
            )}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedItems([...selectedItems, record]);
              } else {
                setSelectedItems(
                  selectedItems.filter((item: any) => item.id !== record.id)
                );
              }
            }}
          />
        );
      },
    },
    {
      title: `${t("barcode")}`,
      key: "barcode",
      width: "10rem",
      className: "table-row main",
      render: (record) => {
        return <>{record.item.barcode}</>;
      },
    },
    {
      title: "Name",
      key: "name",
      className: "table-row main",
      render: (record) => {
        return <>{record.item.name}</>;
      },
    },
    {
      title: `${t("quantity")}`,
      key: "currentQuantity",
      dataIndex: "currentQuantity",
      width: "6rem",
      className: "table-row main",
    },
    {
      title: `${t("price")}`,
      dataIndex: "lastPriceText",
      key: "lastPriceText",
      width: "6rem",
      className: "table-row main",
    },
  ];
  const renderCell = ({
    children,
    ...props
  }: React.HTMLAttributes<HTMLElement>) => {
    return <td {...props}>{children}</td>;
  };

  return (
    <Table
      key={tableKey}
      dataSource={items}
      columns={columns}
      loading={isLoading}
      className="main ant-table-thead"
      rowClassName={(record, index) =>
        index % 2 === 0
          ? "table-row-light table-row"
          : "table-row-dark table-row"
      }
      rowKey={(record: any) => record.id}
      components={{
        body: {
          cell: renderCell, // Use the custom cell renderer
        },
      }}
      onChange={(pageObj) => {
        if (pageObj.current || 1 >= page) setPage(pageObj.current || 1);
      }}
    />
  );
};

export default ItemsList;
